import {Component, NgZone, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Subject} from 'rxjs/Subject';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {TessereService} from '../../servizi/tessere/tessere.service';

@Component({
  selector: 'app-genera-tesserino',
  templateUrl: './genera-tesserino.component.html'
})
export class GeneraTesserinoComponent implements OnInit {

  regularForm: FormGroup;
  subscriber: any;
  request: any;
  discipline1: any;
  discipline2: any;
  discipline3: any;

  public onClose: Subject<any>;

  constructor(
    public bsModalRef: BsModalRef,
    private tessereService: TessereService
  ) {
  }

  ngOnInit() {
    this.onClose = new Subject();
  }

  generaTesserino() {
    const request: any = {};
    request.cardCode = this.subscriber.cardCode;
    request.disciplineQualifications = [];
    if (this.discipline1) {
      request.disciplineQualifications.push(this.subscriber.disciplines[this.discipline1])
    }
    if (this.discipline2) {
      request.disciplineQualifications.push(this.subscriber.disciplines[this.discipline2])
    }
    if (this.discipline3) {
      request.disciplineQualifications.push(this.subscriber.disciplines[this.discipline3])
    }
    this.tessereService.generateTecnicalCard(this.subscriber.id, request).subscribe(
      (res: Blob) => {
        const blob = new Blob([res], { type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.id = 'download-link';
        link.href = url;
        link.download = 'Tesserino ' + this.subscriber.cardCode + '.pdf';
        document.body.appendChild(link);
        // document.getElementById('download-link').remove();
        link.click();
        setTimeout(function(){
          document.getElementById('download-link').remove();
        }, 100);
        this.bsModalRef.hide();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/genera-tesserino/genera-tesserino.component.ts